module.exports = __webpack_public_path__ + "img/2_169.983d13ce.png";